import React from 'react'
import "../../index.css"

export default function ErrorAlert({ children }) {
    return (
        <div className="error_alert">{children}</div>
    )
}
